import { inject, Injectable } from '@angular/core';
import { TranslationService } from 'tms-lib';
import { Charts } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class TmsWebTranslationService {
  private readonly translationService = inject(TranslationService);

  load() {
    this.translationService.translateMenu = (key: string) => this.translateMenu(key);
    this.translationService.translateChart = (key: string) => this.translateChart(key);
  }

  translateMenu(value: string): string {
    switch (value) {
      case 'Addresses':
        return $localize`Addresses`;
      case 'Additional Product Costs':
        return $localize`Additional Product Costs`;
      case 'Administration':
        return $localize`Administration`;
      case 'Analysis':
        return $localize`Analysis`;
      case 'Application Settings':
        return $localize`Application Settings`;
      case 'Archive Invoices':
        return $localize`Archive Invoices`;
      case 'Assistant Usage':
        return $localize`Assistant Usage`;
      case 'Banks':
        return $localize`Banks`;
      case 'Bonded Stock':
        return $localize`Bonded Stock`;
      case 'Bonded Stock Adjustment Reasons':
        return $localize`Bonded Stock Adjustment Reasons`;
      case 'Bonded Stock Analysis':
        return $localize`Bonded Stock Analysis`;
      case 'Bonded Stock Transaction Types':
        return $localize`Bonded Stock Transaction Types`;
      case 'Capability Check':
        return $localize`Capability Check`;
      case 'Capacity Load':
        return $localize`Capacity Load`;
      case 'Categories':
        return $localize`Categories`;
      case 'Charge Types':
        return $localize`Charge Types`;
      case 'Colours':
        return $localize`Colours`;
      case 'Commodity Codes':
        return $localize`Commodity Codes`;
      case 'Connections':
        return $localize`Connections`;
      case 'Connection Types':
        return $localize`Connection Types`;
      case 'Contact Types':
        return $localize`Contact Types`;
      case 'Count Systems':
        return $localize`Count Systems`;
      case 'Countries':
        return $localize`Countries`;
      case 'Currencies':
        return $localize`Currencies`;
      case 'Credit Note Reasons':
        return $localize`Credit Note Reasons`;
      case 'Credit Note Statuses':
        return $localize`Credit Note Statuses`;
      case 'Credit Notes':
        return $localize`Credit Notes`;
      case 'Custom Product Specs':
        return $localize`Custom Product Specs`;
      case 'Customer Documents':
        return $localize`Customer Documents`;
      case 'Customers':
        return $localize`Customers`;
      case 'Customer Orders':
        return $localize`Customer Orders`;
      case 'Customer Stock Enquiry':
        return $localize`Customer Stock Enquiry`;
      case 'Customer Sub Types':
        return $localize`Customer Sub Types`;
      case 'Customer Trade Groups':
        return $localize`Customer Trade Groups`;
      case 'Customer Types':
        return $localize`Customer Types`;
      case 'Customs Declaration':
        return $localize`Customs Declaration`;
      case 'Customs Transaction Types':
        return $localize`Customs Transaction Types`;
      case 'Delivery Periods':
        return $localize`Delivery Periods`;
      case 'Delivery Terms':
        return $localize`Delivery Terms`;
      case 'Departments':
        return $localize`Departments`;
      case 'Designs':
        return $localize`Designs`;
      case 'Draft Plans':
        return $localize`Draft Plans`;
      case 'Basic Weaves':
        return $localize`Basic Weaves`;
      case 'Beam Types':
        return $localize`Beam Types`;
      case 'Fibres':
        return $localize`Fibres`;
      case 'Finish Codes':
        return $localize`Finish Codes`;
      case 'Outside Dents':
        return $localize`Outside Dents`;
      case 'Schedule Calendar':
        return $localize`Schedule Calendar`;
      case 'Selvedge Colours':
        return $localize`Selvedge Colours`;
      case 'Twist Directions':
        return $localize`Twist Directions`;
      case 'Warp Types':
        return $localize`Warp Types`;
      case 'Field Labels':
        return $localize`Field Labels`;
      case 'Document':
        return $localize`Document`;
      case 'Documents':
        return $localize`Documents`;
      case 'Email Purchase Orders':
        return $localize`Email Purchase Orders`;
      case 'Email Sales Invoices':
        return $localize`Email Sales Invoices`;
      case 'Fabrics':
        return $localize`Fabrics`;
      case 'Funnel Files':
        return $localize`Funnel Files`;
      case 'Goods Delivery Notes':
        return $localize`Goods Delivery Notes`;
      case 'Goods Received Notes':
        return $localize`Goods Received Notes`;
      case 'Grades':
        return $localize`Grades`;
      case 'Held Orders':
        return $localize`Held Orders`;
      case 'Invoice Statuses':
        return $localize`Invoice Statuses`;
      case 'Label Placements':
        return $localize`Label Placements`;
      case 'Location Types':
        return $localize`Location Types`;
      case 'Locations':
        return $localize`Locations`;
      case 'Log in':
        return $localize`Log in`;
      case 'Log out':
        return $localize`Log out`;
      case 'Magento Products':
        return $localize`Magento Products`;
      case 'Magento Stock':
        return $localize`Magento Stock`;
      case 'Machines':
        return $localize`Machines`;
      case 'Machine Types':
        return $localize`Machine Types`;
      case 'Make Ups':
        return $localize`Make Ups`;
      case 'Manage Sales Orders':
        return $localize`Manage Sales Orders`;
      // The menu GROUP name, not an item - groups are translated through here too.
      case 'Manufacturing':
        return $localize`Manufacturing`;
      case 'Magento Sales Orders':
        return $localize`Magento Sales Orders`;
      case 'Magento Shipping Details':
        return $localize`Magento Shipping Details`;
      case 'Measure Descriptions':
        return $localize`Measure Descriptions`;
      case 'Month End Stock':
        return $localize`Month End Stock`;
      case 'Narratives':
        return $localize`Narratives`;
      case 'Modes Of Transport':
        return $localize`Modes Of Transport`;
      case 'Nominal Codes':
        return $localize`Nominal Codes`;
      case 'Operators':
        return $localize`Operators`;
      case 'Order Line Statuses':
        return $localize`Order Line Statuses`;
      case 'Order Sources':
        return $localize`Order Sources`;
      case 'Order Statuses':
        return $localize`Order Statuses`;
      case 'Order Types':
        return $localize`Order Types`;
      case 'Origins':
        return $localize`Origins`;
      case 'Pack Types':
        return $localize`Pack Types`;
      case 'Payment Methods':
        return $localize`Payment Methods`;
      case 'Payment Terms':
        return $localize`Payment Terms`;
      case 'Payment Types':
        return $localize`Payment Types`;
      // Renamed so "Picking List" is free for the new standalone picking-list document -
      // the case labels still match the seeded DB menu Names.
      case 'Peg Plans':
        return $localize`Peg Plans`;
      case 'Picking List':
        return $localize`Picking`;
      case 'Picking List - Multi Select':
        return $localize`Picking - Multi Select`;
      // Seeded by the AddDoNotAllowConfirmAndUnpostInvoicesMenu migration - keep identical.
      case 'Picking List Lines':
        return $localize`Picking List Lines`;
      case 'Picking Lists':
        return $localize`Picking Lists`;
      case 'Transfers':
        return $localize`Transfers`;
      // Seeded by the AddTransferRequests migration - keep identical.
      case 'Transfer Requests':
        return $localize`Transfer Requests`;
      case 'Translations':
        return $localize`Translations`;
      case 'Shift Patterns':
        return $localize`Shift Patterns`;
      case 'Ports':
        return $localize`Ports`;
      case 'Price Bands':
        return $localize`Price Bands`;
      case 'Price Change Reasons':
        return $localize`Price Change Reasons`;
      case 'Job Statuses':
        return $localize`Job Statuses`;
      case 'Jobs':
        return $localize`Jobs`;
      case 'Pick Wheels':
        return $localize`Pick Wheels`;
      case 'Piece Progress':
        return $localize`Piece Progress`;
      case 'Texplan':
        return $localize`Texplan`;
      case 'Traffic Light System':
        return $localize`Traffic Light System`;
      case 'Traffic Light Steps':
        return $localize`Traffic Light Steps`;
      case 'Yarn Qualities':
        return $localize`Yarn Qualities`;
      case 'Piece Statuses':
        return $localize`Piece Statuses`;
      case 'Pieces':
        return $localize`Pieces`;
      case 'Price List':
        return $localize`Price List`;
      case 'Printers':
        return $localize`Printers`;
      case 'Print Methods':
        return $localize`Print Methods`;
      case 'Process Routes':
        return $localize`Process Routes`;
      case 'Processes':
        return $localize`Processes`;
      case 'Product Groups':
        return $localize`Product Groups`;
      case 'Product Type Groups':
        return $localize`Product Type Groups`;
      case 'Product Types':
        return $localize`Product Types`;
      case 'Production':
        return $localize`Production`;
      case 'Production Calendar':
        return $localize`Production Calendar`;
      case 'Production Orders':
        return $localize`Production Orders`;
      case 'Production Processes':
        return $localize`Production Processes`;
      case 'Products':
        return $localize`Products`;
      case 'Proforma Orders':
        return $localize`Proforma Orders`;
      case 'Proforma Payment Analysis':
        return $localize`Proforma Payment Analysis`;
      case 'Purchase Contract Book':
        return $localize`Purchase Contract Book`;
      case 'Purchase Contract Line Item':
        return $localize`Purchase Contract Line Item`;
      case 'Purchase Contracts':
        return $localize`Purchase Contracts`;
      case 'Purchase Deliveries':
        return $localize`Purchase Deliveries`;
      case 'Purchase Invoices':
        return $localize`Purchase Invoices`;
      case 'Purchase Orders':
        return $localize`Purchase Orders`;
      case 'Purchase Price Bands':
        return $localize`Purchase Price Bands`;
      case 'Purchase Order Production Item':
        return $localize`Purchase Order Production Item`;
      case 'Purchase Order Production Statuses':
        return $localize`Purchase Order Production Statuses`;
      case 'Purchase Order Book':
        return $localize`Purchase Order Book`;
      case 'Purchase Order Despatches':
        return $localize`Purchase Order Despatches`;
      case 'Purchase Orders for Completing':
        return $localize`Purchase Orders for Completing`;
      case 'Purchase Order Line Item':
        return $localize`Purchase Order Line Item`;
      case 'Purchase Order Receipts':
        return $localize`Purchase Order Receipts`;
      case 'Purchase Order Receipts - Multi Select':
        return $localize`Purchase Order Receipts - Multi Select`;
      case 'Purchase Order Statuses':
        return $localize`Purchase Order Statuses`;
      case 'Purchase Receipts':
        return $localize`Purchase Receipts`;
      case 'Purchasing':
        return $localize`Purchasing`;
      case 'Qualities':
        return $localize`Qualities`;
      case 'Relocate Stock':
        return $localize`Relocate Stock`;
      case 'Replenishment':
        return $localize`Replenishment`;
      case 'Reporting':
        return $localize`Reporting`;
      case 'Reports':
        return $localize`Reports`;
      case 'Reserved Orders':
        return $localize`Reserved Orders`;
      case 'Returnable Product Orders':
        return $localize`Returnable Product Orders`;
      case 'Sales':
        return $localize`Sales`;
      case 'Sales Agents Commission':
        return $localize`Sales Agents Commission`;
      case 'Sales Contract Line Item':
        return $localize`Sales Contract Line Item`;
      case 'Sales Contracts':
        return $localize`Sales Contracts`;
      case 'Sales Despatch Notes':
        return $localize`Sales Despatch Notes`;
      case 'Sales Despatch Note Statuses':
        return $localize`Sales Despatch Note Statuses`;
      case 'Sales Discounts':
        return $localize`Sales Discounts`;
      case 'Sales Invoices':
        return $localize`Sales Invoices`;
      case 'Sales Analysis':
        return $localize`Sales Analysis`;
      case 'Sales Despatch Analysis':
        return $localize`Sales Despatch Analysis`;
      case 'Sales Manifest Items':
        return $localize`Sales Manifest Items`;
      case 'Sales Manifests':
        return $localize`Sales Manifests`;
      case 'Sales Order Analysis':
        return $localize`Sales Order Analysis`;
      case 'Sales Order Book':
        return $localize`Sales Order Book`;
      case 'Sales Orders for Completing':
        return $localize`Sales Orders for Completing`;
      case 'Sales Order Line Item':
        return $localize`Sales Order Line Item`;
      case 'Sales Order Line Multi Pick':
        return $localize`Sales Order Line Multi Pick`;
      case 'Sales Orders Not Passed Credit':
        return $localize`Sales Orders Not Passed Credit`;
      case 'Sales Order Payments':
        return $localize`Sales Order Payments`;
      case 'Sales Orders':
        return $localize`Sales Orders`;
      case 'Sales Packs':
        return $localize`Sales Packs`;
      case 'Sales Price Bands':
        return $localize`Sales Price Bands`;
      case 'Sales/Purchase Properties':
        return $localize`Sales Purchase Property`;
      case 'Sales Regions':
        return $localize`Sales Regions`;
      case 'Selling Companies':
        return $localize`Selling Companies`;
      case 'Selvedge Specs':
        return $localize`Selvedge Specs`;
      case 'Selvedge Wordings':
        return $localize`Selvedge Wordings`;
      case 'Service Reps':
        return $localize`Service Reps`;
      case 'Settings':
        return $localize`Settings`;
      case 'Settlement Terms':
        return $localize`Settlement Terms`;
      case 'Shipper Accounts':
        return $localize`Shipper Accounts`;
      case 'Shipper Account Interface Types':
        return $localize`Shipper Account Interface Types`;
      case 'Shipper Interface':
        return $localize`Shipper Interface`;
      case 'Shipping Charge Bands':
        return $localize`Shipping Charge Bands`;
      case 'Shipping Packs':
        return $localize`Shipping Packs`;
      case 'Shipping Payment Routes':
        return $localize`Shipping Payment Routes`;
      case 'Shipping Regions':
        return $localize`Shipping Regions`;
      case 'Shipping Services':
        return $localize`Shipping Services`;
      case 'Sizes':
        return $localize`Sizes`;
      case 'Stock':
        return $localize`Stock`;
      case 'Stock Adjustment Reasons':
        return $localize`Stock Adjustment Reasons`;
      case 'Re-allocate Stock':
        return $localize`Re-allocate Stock`;
      case 'Stock Allocations':
        return $localize`Stock Allocations`;
      case 'Stock Enquiry':
        return $localize`Stock Enquiry`;
      case 'Stock Exposure':
        return $localize`Stock Exposure`;
      case 'Stock Forecasting':
        return $localize`Stock Forecasting`;
      case 'Stock for Cutting':
        return $localize`Stock for Cutting`;
      case 'Stock for Cutting by Order':
        return $localize`Stock for Cutting by Order`;
      case 'Stock for Cutting by Picking List':
        return $localize`Stock for Cutting by Picking List`;
      case 'Stock Items':
        return $localize`Stock Items`;
      case 'Stock Item Transaction Analysis':
        return $localize`Stock Item Transaction Analysis`;
      case 'Stock Properties':
        return $localize`Stock Properties`;
      case 'Supplementary Invoices':
        return $localize`Supplementary Invoices`;
      case 'Supplementary Types':
        return $localize`Supplementary Types`;
      case 'Supplier Despatch Notes':
        return $localize`Supplier Despatch Notes`;
      case 'Supplier Documents':
        return $localize`Supplier Documents`;
      case 'Supplier Shipments':
        return $localize`Supplier Shipments`;
      case 'Suppliers':
        return $localize`Suppliers`;
      case 'Taxes':
        return $localize`Taxes`;
      case 'Third Party Shipper Accounts':
        return $localize`Third Party Shipper Accounts`;
      case 'Titles':
        return $localize`Titles`;
      case 'Trim Descriptions':
        return $localize`Trim Descriptions`;
      case 'Un-Bonded Stock Analysis':
        return $localize`Un-Bonded Stock Analysis`;
      // Seeded by the AddDoNotAllowConfirmAndUnpostInvoicesMenu migration - keep identical.
      case 'Un-post Invoices':
        return $localize`Un-post Invoices`;
      // Seeded by the AddUndoRoutines migration (Ross Un-do routines) - keep identical.
      case 'Un-post Purchase Invoices':
        return $localize`Un-post Purchase Invoices`;
      case 'Unit of Measures':
        return $localize`Unit of Measures`;
      case 'Update External Orders':
        return $localize`Update External Orders`;
      case 'Update Shipped Orders':
        return $localize`Update Shipped Orders`;
      case 'Warehouses':
        return $localize`Warehouses`;
      case 'Website Shipping Details':
        return $localize`Website Shipping Details`;
    }

    return this.translationService.translateMenuItems(value);
  }

  translateChart(value: string): string {
    switch (value) {
      case Charts.SalesOrders:
        return $localize`Sales Orders`;
      case Charts.SalesInvoices:
        return $localize`Sales Invoices`;
      case Charts.SalesContracts:
        return $localize`Sales Contracts`;
      case Charts.PurchaseOrders:
        return $localize`Purchase Orders`;
      case Charts.PurchaseInvoices:
        return $localize`Purchase Invoices`;
      default:
        return undefined;
    }
  }

  // Translates a chosen field label (weaving WS10) - the label is a DB-stored
  // synonym (see FieldLabelSynonyms), so extract-i18n never sees it. Every
  // synonym needs a case here or it shows English-only in other languages.
  translateFieldLabel(value: string): string {
    switch (value) {
      case 'Quality':
        return $localize`Quality`;
      case 'Pattern':
        return $localize`Pattern`;
      case 'Product Quality':
        return $localize`Product Quality`;
      case 'Design':
        return $localize`Design`;
      case 'Range':
        return $localize`Range`;
      case 'Colourway':
        return $localize`Colourway`;
      case 'Shade':
        return $localize`Shade`;
      case 'Sett':
        return $localize`Sett`;
      case 'E.P.I':
        return $localize`E.P.I`;
      case 'Setting':
        return $localize`Setting`;
      case 'Sley':
        return $localize`Sley`;
      case 'Ends':
        return $localize`Ends`;
      case 'Ground Ends':
        return $localize`Ground Ends`;
      case 'Grd':
        return $localize`Grd`;
      case 'Picks':
        return $localize`Picks`;
      case 'Req. Px':
        return $localize`Req. Px`;
      case 'Shots':
        return $localize`Shots`;
      case 'Count':
        return $localize`Count`;
      case 'Grist':
        return $localize`Grist`;
      case 'Reed Width':
        return $localize`Reed Width`;
      case 'Width':
        return $localize`Width`;
      case 'Loom Width':
        return $localize`Loom Width`;
      case 'Extras':
        return $localize`Extras`;
      case 'AS':
        return $localize`AS`;
      default:
        return value;
    }
  }
}
